import { GraduationCap, Award, BookOpen } from "lucide-react";
import { motion } from "framer-motion";

export default function Elementos({
  titulo,
  diplomados,
  certificaciones,
  microcredenciales,
}) {
  return (
    <section className="py-24  px-6 ">
      <div className="max-w-6xl mx-auto">
        {/* Título de la sección mejorado estéticamente */}
        {titulo && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35}}
          >
            <div
              className=" [&_h2]:font-bold [&_h2_strong]:text-[#febe10] mb-10  max-w-2xl m-auto text-center "
              dangerouslySetInnerHTML={{ __html: titulo }}
            />
          </motion.div>
        )}

        {/* Contenedor cambiado a FLEX para centrar las tarjetas */}
        <div className="flex flex-wrap justify-center gap-6">
          {/* Tarjeta 1: Diplomados (Gris Claro) */}
          {diplomados && (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, delay: 0.5 }}
              className=" w-[calc(50%-12px)] p-6 bg-[#f9f9f9] rounded-xl border border-gray-200/60 shadow-sm hover:shadow-md transition-shadow duration-200 min-h-[190px]"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-white rounded-lg flex-shrink-0">
                  <GraduationCap
                    className="w-6 h-6"
                    style={{ color: "#004270" }}
                  />
                </div>
              </div>

              <div
                className=" [&_h2]:font-bold"
                dangerouslySetInnerHTML={{ __html: diplomados }}
              />
            </motion.div>
          )}

          {/* Tarjeta 2: Certificaciones (Gris Medio) */}
          {certificaciones && (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, delay: 0.6 }}
              className=" md:w-[calc(50%-12px)] p-6 bg-[#f8f8f8] rounded-xl border border-gray-300/60 shadow-sm hover:shadow-md transition-shadow duration-200 min-h-[190px] "
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-white rounded-lg flex-shrink-0">
                  <Award className="w-6 h-6" style={{ color: "#004270" }} />
                </div>
              </div>

              <div
                className=" [&_h2]:font-bold"
                dangerouslySetInnerHTML={{ __html: certificaciones }}
              />
            </motion.div>
          )}

          {/* Tarjeta 3: Microcredenciales (Gris Más Oscuro) */}
          {microcredenciales && (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, delay: 0.7 }}
              className=" md:w-[calc(50%-12px)] p-6  bg-[#f7f7f7] rounded-xl border border-gray-400/40 shadow-sm hover:shadow-md transition-shadow duration-200 min-h-[190px] "
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-white rounded-lg flex-shrink-0">
                  <BookOpen className="w-6 h-6" style={{ color: "#004270" }} />
                </div>
              </div>

              <div
                className=" [&_h2]:font-bold"
                dangerouslySetInnerHTML={{ __html: microcredenciales }}
              />
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
}
